import en from './en.json';
import ko from './ko.json';

export type Locale = 'en' | 'ko';

const DICTS: Record<Locale, Record<string, string>> = { en, ko };
const STORAGE_KEY = 'yodajjom.locale.v1';

let currentLocale: Locale = detectInitialLocale();

function detectInitialLocale(): Locale {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'en' || saved === 'ko') return saved;
  } catch {}
  const nav = (typeof navigator !== 'undefined' && navigator.language) || 'en';
  return nav.toLowerCase().startsWith('ko') ? 'ko' : 'en';
}

export function getLocale(): Locale {
  return currentLocale;
}

export function setLocale(loc: Locale) {
  currentLocale = loc;
  try {
    localStorage.setItem(STORAGE_KEY, loc);
  } catch {}
}

export function t(key: string, params?: Record<string, string | number>): string {
  const dict = DICTS[currentLocale] ?? DICTS.en;
  let s = dict[key] ?? DICTS.en[key] ?? key;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      s = s.split(`{${k}}`).join(String(v));
    }
  }
  return s;
}
